import { render, staticRenderFns } from "./InstituitionInvite.vue?vue&type=template&id=0ce15e5e"
import script from "./InstituitionInvite.vue?vue&type=script&lang=js"
export * from "./InstituitionInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports